import { CommonModal } from 'components'
import { makeAvaVehicleTrip } from 'features';
import React, { useState } from 'react'
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { StorageServices } from 'utils';

const MakeTruckAvailableModal = (props) => {
  const { vehicleId,closeModal,callBackEnd=()=>{} } = props;
  const dispatch = useDispatch();
  const [isLoadding, setIsLoadding] = useState(false);
console.log(vehicleId)
  const onSubmitEnd = async () => {


    const payload = {
      company_id: StorageServices.getCompanyId(),
      vehicle_id: vehicleId?._id,
      vehicle_status: 1,
    };


    setIsLoadding(true);
    try {
      const res = await dispatch(makeAvaVehicleTrip(payload));

      if (res?.payload?.responseCode === 200) {
        setIsLoadding(false);
        closeModal();
        callBackEnd(vehicleId);
        // callBackEndForList(res?.payload?.data?.trip);
        toast.success(res?.payload?.responseMessage)
      } else {
        setIsLoadding(false);
        // toast.error(res?.payload?.responseMessage)
      }
    } catch {
      setIsLoadding(false);
    }

  };


  const propsMarkTruck = {
    ...props,
    isLoadding: isLoadding,
    disabled: isLoadding,
    onSubmit: onSubmitEnd,
  };

  return (
    <>
      <CommonModal {...propsMarkTruck}>
        <div className='endTrip_bxs pt-2'>

          <div className='_transDetail_bx _mkTrkDetail_bx'>

            <div className='_trkDetail'>
              <h6 className='_trkNum'>MP20 GA 2108</h6>
              <div className='_trkMark'>Market</div>
              <div className='_trkTyre'><span>32Feet XL</span></div>
            </div>

            <div className='_trkStatus'><span className='_maintainance'></span> Maintainance</div>

          </div>

        </div>
      </CommonModal>
    </>
  )
}

export default MakeTruckAvailableModal